import interact from 'interactjs';
import { filingInstructionsStorage } from '@/utils/filingInstructionsStorage';

export default {
  methods: {
    toggleFilingInstructions() {
      if (!this.filingInstructionsVisible) {
        const savedPosition = filingInstructionsStorage.getPosition();
        if (savedPosition) {
          this.$emit('update:filingInstructionsPosition', savedPosition);
        } else {
          this.$emit('update:filingInstructionsPosition', 'bottom');
        }
        this.$emit('update:filingInstructionsVisible', true);
      } else {
        this.$emit('update:filingInstructionsVisible', false);
      }
    },
  },
};
